import { DateUtils } from "@/utils/dateUtil";

export default function BadgeIsNew({ createAt }: { createAt: string }) {
  return (
    <>
      {DateUtils.isNew(createAt) && (
        <span className="text-[8px] bg-red-400 text-white size-3 text-center rounded-[3px] ml-1">
          N
        </span>
      )}
    </>
  );
}
